import { CardActionArea } from "@mui/material";
import { WhmCard, WhmCardContent, SxProps } from "@securitize/reactjs-whm";
import { Link, LinkProps } from "react-router-dom";

type StyledCardProps = {
  sx?: SxProps;
  onClick?: () => void;
  href?: string;
  to?: LinkProps["to"];
} & Parameters<typeof WhmCardContent>[0];

export default function StyledCard({
  onClick,
  href,
  to,
  sx,
  ...rest
}: StyledCardProps) {
  if (to || onClick || href) {
    return (
      <WhmCard sx={sx} variant="outlined">
        {/* @ts-expect-error -- CardActionArea can't know when exactly it has a to */}
        <CardActionArea
          onClick={onClick}
          href={href as string}
          to={to as string}
          component={to ? Link : undefined}
          disableRipple
          sx={{
            "&:hover": {
              color: "inherit",
              backgroundColor: (theme) => theme.palette.grey[50],
            },
            "& .MuiCardActionArea-focusHighlight": {
              transition: "none",
            },
          }}
        >
          <WhmCardContent {...rest} />
        </CardActionArea>
      </WhmCard>
    );
  } else {
    return (
      <WhmCard sx={sx} variant="outlined">
        <WhmCardContent
          sx={{
            "&:last-child": {
              paddingBottom: "16px",
            },
          }}
          {...rest}
        />
      </WhmCard>
    );
  }
}
